import React, { useEffect, useId, useRef } from 'react';
import { InlineError } from '../InlineError/InlineError.js';
const styles = {"textField":"TextField-module__textField__FiXFS","label":"TextField-module__label__9LAIG","input":"TextField-module__input__GDkcH","hint":"TextField-module__hint__R-JW2"};
/**
 * A labelled single-line field (Foundations · TextField board, frames C1–C3). The error is tied to the input with
 * `aria-describedby` and `aria-invalid`.
 */
export function TextField({ label, value, onChange, placeholder, hint, error, errorRevision, type = 'text', autoComplete, required, disabled, autoFocus }) {
    const inputId = useId();
    const descriptionId = `${inputId}-description`;
    const inputRef = useRef(null);
    const hasError = error !== undefined && error !== '';
    const hasHint = hint !== undefined && hint !== '';
    let description = null;
    let describedBy;
    useEffect(() => {
        if (autoFocus === true) {
            inputRef.current?.focus();
        }
    }, [autoFocus]);
    useEffect(() => {
        if (error !== undefined && error !== '') {
            inputRef.current?.focus();
        }
    }, [error, errorRevision]);
    if (hasError) {
        description = React.createElement(InlineError, { id: descriptionId, message: error });
        describedBy = descriptionId;
    }
    else if (hasHint) {
        description = React.createElement("span", { className: styles.hint, id: descriptionId }, hint);
        describedBy = descriptionId;
    }
    return (React.createElement("div", { className: styles.textField, "data-disabled": disabled === true ? 'true' : undefined },
        React.createElement("label", { className: styles.label, htmlFor: inputId }, label),
        React.createElement("input", { ref: inputRef, id: inputId, className: styles.input, type: type, value: value, placeholder: placeholder, autoComplete: autoComplete, required: required === true, disabled: disabled === true, "aria-invalid": hasError ? 'true' : undefined, "aria-describedby": describedBy, "data-error": hasError ? 'true' : undefined, onChange: event => onChange(event.target.value) }),
        description));
}
//# sourceMappingURL=TextField.js.map